import type { CustomView } from "@productlane/zero/schema"

import type { ThreadTab } from "./use-inbox-tabs"

export type SidebarEntry =
	| { type: "tab"; value: ThreadTab["value"] }
	| { type: "view"; view: CustomView }

export function buildSidebarEntries(
	tabs: readonly ThreadTab[],
	customViews: readonly CustomView[],
): SidebarEntry[] {
	return [
		...tabs.map((tab) => ({ type: "tab" as const, value: tab.value })),
		...customViews.map((view) => ({ type: "view" as const, view })),
	]
}

export function activeSidebarEntryIndex(
	entries: readonly SidebarEntry[],
	inboxState: string,
	activeCustomViewId: string | null,
): number {
	return entries.findIndex((entry) => {
		if (entry.type === "view") return entry.view.id === activeCustomViewId
		return !activeCustomViewId && entry.value === inboxState
	})
}

export function nextSidebarEntryIndex(
	entries: readonly SidebarEntry[],
	currentIndex: number,
	direction: "forward" | "backward",
): number {
	if (currentIndex === -1) return 0
	return direction === "forward"
		? (currentIndex + 1) % entries.length
		: (currentIndex - 1 + entries.length) % entries.length
}
